import { COLORS } from 'helpers/globals'
import { column } from 'helpers/styles/grid'

export default {
  details: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  container: {
    padding: '.8rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  goBackButton: {
    marginRight: 7
  },
  destroyButton: {
    color: 'red',
    fontSize: '1.9rem',
    float: 'right',
    marginRight: '1rem'
  },
  actions: {
    marginLeft: '1.5rem',
    fontSize: '2rem',
    flexShrink: 0,
    '& a:not(:last-of-type)': { marginRight: '1rem' }
  },
  label: {
    lineHeight: '3.5rem',
    ...column,
    padding: '0!important',
    marginRight: '0!important',
    color: 'black',
    flex: '0 0 15%',
    maxWidth: '15%'
  },
  colorLabel: {
    color: 'black',
    width: '5rem',
    flexShrink: 0
  },
  typesContainer: {
    display: 'flex',
    flex: '1 1 auto',
    fontSize: '1.6rem',
    flexWrap: 'wrap',
    gap: '.5rem 1.75rem',
    marginRight: '1rem'
  },
  type: {
    borderRadius: '50%',
    flex: '0 1 3rem',
    height: '3rem',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': { boxShadow: `0 0 3px 1px ${COLORS.secondary}` },
    '&:not(last-of-type)': { marginRight: '1rem' }
  },
  otherLabel: {
    color: 'black',
    flexShrink: 0,
    width: '11rem'
  },
  input: {
    flex: '0 0 55%'
  }
}



// WEBPACK FOOTER //
// ./src/components/WiredDeviceDetails/style.js